export default {
    namespaced: true,
    state: {
        lastSaved: null,
        activeSectionId: null
    },
    mutations: {
        lastSaved(state, timestamp) {
            state.lastSaved = timestamp
        },
        activeSectionId(state, id) {
            state.activeSectionId = id
        }
    }
}
